import { styled } from 'shared/ui';

export const SysDiaWrap = styled('div', {
  display: 'flex',
  gap: '48px',
});
